import { getQualId } from "../../helpers/qualificationIdentifier";

export default function class_request_form(
  state = {
    qualification: { id: getQualId("alevel"), name: "A-Level" },
  },
  action
) {
  switch (action.type) {
    case "REQUEST_CLASS":
      return {
        ...state,
        qualification: action.payload,
      };

    default:
      return state;
  }
}
